(function () {
  // International Product Blocker - generated asset script.
  // Upload this file to your theme's Assets folder and reference it with:
  // <script src="{{ 'intl-product-blocker.js' | asset_url }}" defer></script>
  // It reads the current product's tags from a hidden data element you add
  // to the product template (see instructions in the app).

  var BLOCKED_TAGS = ["dangerous"];
  var ALLOWED_COUNTRIES = ["AU"];
  var BLOCK_MESSAGE = "***Not Available to Your Country***  Unfortunately these products cannot be shipped outside of Australia due to safety reasons: Gas struts and Paint.";
  var DETECTION_MODE = "shopify";

  function getProductTags() {
    // Reads tags from a data attribute you render on the page, e.g.:
    // <div id="ipb-product-data" data-tags="{{ product.tags | join: ',' }}"></div>
    var el = document.getElementById('ipb-product-data');
    if (!el) return [];
    var raw = el.getAttribute('data-tags') || '';
    return raw.split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
  }

  function productIsBlocked() {
    var tags = getProductTags();
    for (var i = 0; i < BLOCKED_TAGS.length; i++) {
      if (tags.indexOf(BLOCKED_TAGS[i]) !== -1) return true;
    }
    return false;
  }

  function normalizeCountry(code) {
    return (code || '').toString().trim().toUpperCase();
  }

  function detectCountryShopify(cb) {
    // NOTE: This mode is NOT IP-based. It reflects the country the customer has
    // selected in your storefront (or their locale), so it will not work for VPN
    // testing. Use ipapi.co geolocation for real IP-based detection.
    var code = '';
    try {
      if (window.Shopify && window.Shopify.country) {
        code = window.Shopify.country;
      }
    } catch (e) {}
    if (!code) {
      try {
        // window.Shopify.locale looks like 'en-AU'; take the region after the dash.
        if (window.Shopify && window.Shopify.locale && window.Shopify.locale.indexOf('-') !== -1) {
          code = window.Shopify.locale.split('-').pop();
        }
      } catch (e) {}
    }
    if (!code) {
      // Read a 'cart_currency' cookie if present (currency code, e.g. AUD).
      var match = document.cookie.match(/(?:^|; )cart_currency=([^;]+)/);
      if (match && match[1]) code = decodeURIComponent(match[1]);
    }
    if (!code) {
      // Fall back to a localization meta tag if the theme renders one.
      var meta = document.querySelector('meta[name="shopify-country"], meta[property="og:country-name"]');
      if (meta && meta.getAttribute('content')) code = meta.getAttribute('content');
    }
    if (!code) {
      // Final fallback: the localization form country selector, if present.
      var sel = document.querySelector('form[action$="/localization"] select[name="country_code"]');
      if (sel && sel.value) code = sel.value;
    }
    cb(normalizeCountry(code));
  }

  function detectCountryIpapi(cb) {
    fetch('https://ipapi.co/json/')
      .then(function (r) { return r.json(); })
      .then(function (data) { cb(normalizeCountry(data && data.country_code)); })
      .catch(function () { cb(''); });
  }

  function detectCountry(cb) {
    if (DETECTION_MODE === 'ipapi') {
      detectCountryIpapi(cb);
    } else {
      detectCountryShopify(cb);
    }
  }

  function findAddToCartButtons() {
    var selectors = [
      'form[action$="/cart/add"] [type="submit"]',
      'form[action*="/cart/add"] button[name="add"]',
      'button[name="add"]',
      '.product-form__submit',
      '[data-add-to-cart]'
    ];
    var found = [];
    for (var i = 0; i < selectors.length; i++) {
      var nodes = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < nodes.length; j++) {
        if (found.indexOf(nodes[j]) === -1) found.push(nodes[j]);
      }
    }
    return found;
  }

  function getCartForms() {
    return document.querySelectorAll('form[action$="/cart/add"], form[action*="/cart/add"]');
  }

  function showMessageAndReplacement() {
    var forms = getCartForms();
    // Anchor: insert before the first cart form's parent, since the form is now hidden.
    var anchor = null;
    var parent = null;
    if (forms.length > 0 && forms[0].parentNode) {
      anchor = forms[0].parentNode;
      parent = anchor.parentNode;
    }

    // Replacement disabled-looking button carrying the block message (inserted once).
    if (!document.getElementById('ipb-block-button')) {
      var btn = document.createElement('button');
      btn.id = 'ipb-block-button';
      btn.type = 'button';
      btn.setAttribute('disabled', 'disabled');
      btn.textContent = BLOCK_MESSAGE;
      btn.style.display = 'block';
      btn.style.width = '100%';
      btn.style.margin = '12px 0';
      btn.style.padding = '12px 16px';
      btn.style.border = '1px solid #cccccc';
      btn.style.borderRadius = '8px';
      btn.style.background = '#e0e0e0';
      btn.style.color = '#777777';
      btn.style.fontSize = '14px';
      btn.style.cursor = 'not-allowed';
      if (anchor && parent) {
        parent.insertBefore(btn, anchor);
      } else {
        document.body.appendChild(btn);
      }
    }
  }

  function enforce() {
    if (!productIsBlocked()) return;
    if (ALLOWED_COUNTRIES.length === 0) return;
    detectCountry(function (country) {
      if (!country) return;
      // Whitelist: allow customers whose country is in ALLOWED_COUNTRIES; block everyone else.
      if (ALLOWED_COUNTRIES.indexOf(country) !== -1) return;

      // Hide the Add to cart button(s) without disabling them, so themes don't
      // swap in a "Notify Me" / back-in-stock button.
      var buttons = findAddToCartButtons();
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].style.display = 'none';
      }

      // Hide the entire add-to-cart form(s) to prevent any submission.
      var forms = getCartForms();
      for (var k = 0; k < forms.length; k++) {
        forms[k].style.display = 'none';
      }

      // Insert the message and a disabled-looking replacement button (once).
      showMessageAndReplacement();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforce);
  } else {
    enforce();
  }
})();
